"use client";

import { useSidebarThemeStore } from "./useSidebarThemeStore";
import type { ThemeColorScopeProps } from "./types";

/** Returns the data attribute that activates themeColor semantic tokens for descendants. */
export function useThemeColorScope(): ThemeColorScopeProps {
  const themeId = useSidebarThemeStore((state) => state.themeId);
  return { "data-theme-color": themeId };
}

/** @deprecated Use useThemeColorScope */
export const useSidebarThemeScope = useThemeColorScope;
